"use client";
import { useEffect, useState } from "react";
import { useLocale } from "next-intl";
import Image from "next/image";
import { toCockpitImagePath } from "./CockpitImage";
import usePopup from "../hooks/usePopup";
import useCurrentUser from "../../auth/hooks/useCurrentUser";
import { Link, usePathname } from "../../../navigation";
import Modal from "../../theme/components/Modal";
import useCMSPageByID from "../hooks/server/useCMSPageByID";

const displayToCurrentUser = (isPrivate, displayTo, pathname) => {
  if (
    (isPrivate === null || isPrivate === undefined) &&
    displayTo?.includes("anonymous-home") &&
    pathname === "/"
  )
    return true;
  if (isPrivate && displayTo?.includes("private")) return true;
  if (!isPrivate && displayTo?.includes("institution")) return true;
  return false;
};

const Popup = () => {
  const pathname = usePathname();
  const locale = useLocale();

  const [isVisible, setIsVisible] = useState(false);

  const { currentUser, loading: loadingUser } = useCurrentUser();
  const { popup, loading: loadingPopup } = usePopup({
    isPrivate: currentUser?.self?.isPrivateCustomer,
    skip: loadingUser,
  });
  const pageId =
    typeof popup?.link === "string"
      ? popup?.link?.split("pages://")?.[1]
      : null;
  const { page, loading: pageLoading } = useCMSPageByID({ pageId, locale });

  const closePopup = () => {
    window.localStorage.setItem(`popup-displayed-${popup._id}`, "true");
    setIsVisible(false);
  };
  useEffect(() => {
    if (popup && !loadingUser && !loadingPopup) {
      const popupAlreadyShown = window.localStorage.getItem(
        `popup-displayed-${popup?._id}`,
      );
      const popupCanBeShown = displayToCurrentUser(
        currentUser?.self?.isPrivateCustomer,
        popup.displayTo,
        pathname,
      );
      setIsVisible(!popupAlreadyShown && popupCanBeShown);
    }
  }, [popup, currentUser, loadingUser, loadingPopup]);

  if (!isVisible || !popup || pageLoading) return null;
  return (
    <Modal open={isVisible} onClose={closePopup} wide title="">
      <Link href={page?._r || popup?.link} target="_blank" rel="noreferrer">
        {popup.image?.path && (
          <Image
            className="force-position-relative"
            src={toCockpitImagePath(popup.image?.path)}
            alt={popup.image?.title}
            quality={80}
            fill
            sizes="100vw"
            style={{
              objectFit: "contain",
            }}
          />
        )}
      </Link>
    </Modal>
  );
};

export default Popup;
